export enum USER_ROLES {
  TEAMMITGLIED = 'Teammitglied',
  BUDGETVERANTWORTLICHER = 'Budgetverantwortlicher',
  GRUPPENLEITER = 'Gruppenleiter',
  TECHNISCHER_CONTROLLER = 'Technischer Controller',
  KAUFMANNISCHER_CONTROLLER = 'Kaufmännischer Controller',
  TRAVEL_ACCOUNTANT = 'Reisebuchhalter',
  ONLINE_SUPPORT = 'Online Support',
}
